import { forEach } from "lodash-es";
import Glide from '@glidejs/glide';
var Carousel = /** @class */ (function () {
    function Carousel(selector, options) {
        if (options === void 0) { options = {}; }
        document.addEventListener('DOMContentLoaded', function () {
            forEach(document.querySelectorAll(selector), function (carouselElement) {
                var slider = new Glide(carouselElement);
                slider.on(['mount.after', 'run.after'], function () {
                    var activeSlides = carouselElement.querySelectorAll('.glide__slide.glide__slide--active');
                    var hiddenSlides = carouselElement.querySelectorAll('.glide__slide:not(.glide__slide--active)');
                    forEach(hiddenSlides, function (slide) {
                        slide.setAttribute('aria-hidden', 'true');
                        slide.setAttribute('tabindex', '-1');
                    });
                    forEach(activeSlides, function (slide) {
                        slide.setAttribute('aria-hidden', 'false');
                        slide.removeAttribute('tabindex');
                    });
                });
                slider.mount(options);
            });
        });
    }
    return Carousel;
}());
export { Carousel };
